/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React from 'react';

import { Divider, Table, Card, Button } from 'antd';
import Errors from './errors';

const Header = block => {
  const { data, changeMenu, validation } = block;
  console.log(data);

  const getFldNameKey = validationArray => {
    const keys = {};
    validationArray.forEach((element, i) => {
      keys[element.fldName] = i;
    });
    return keys;
  };

  const validatationKeys = getFldNameKey(validation);

  const columns = [
    {
      title: 'PR',
      dataIndex: 'pr',
      key: 'pr',
    },
    {
      title: 'Quantity',
      dataIndex: 'qty',
      key: 'qty',
    },
    {
      title: 'Unit of Issue',
      dataIndex: 'ui',
      key: 'ui',
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitPrc',
      key: 'unitPrc',
    },
    {
      title: 'Delivery Days',
      dataIndex: 'dlvryDays',
      key: 'dlvryDays',
    },
  ];

  const createItems = arr =>
    arr.map(pricingObj => {
      console.log(pricingObj);
      return (
        <div>
          <Divider orientation="left">{pricingObj.line}</Divider>
          <div className="tab-wrapper-small">
            <p>NSN/PN: {pricingObj.nsnOrPn}</p>{' '}
            <p>Nomenclature: {pricingObj.nomenclature}</p>
          </div>
          <div>
            <Table
              pagination={{
                hideOnSinglePage: true,
              }}
              bordered
              dataSource={[pricingObj]}
              columns={columns}
            />
          </div>
          {validatationKeys && validatationKeys.pr ? (
            <Errors validation={validation[validatationKeys.pr]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.qty ? (
            <Errors validation={validation[validatationKeys.qty]} />
          ) : (
            <div />
          )}{' '}
          {validatationKeys && validatationKeys.ui ? (
            <Errors validation={validation[validatationKeys.ui]} />
          ) : (
            <div />
          )}{' '}
          {validatationKeys && validatationKeys.unitPrc ? (
            <Errors validation={validation[validatationKeys.unitPrc]} />
          ) : (
            <div />
          )}{' '}
          {validatationKeys && validatationKeys.dlvryDays ? (
            <Errors validation={validation[validatationKeys.dlvryDays]} />
          ) : (
            <div />
          )}
          <div className="inline">
            <div>
              DO Minimum: <p>{pricingObj.doMin}</p>
            </div>
            <div>
              Contract Maximum: <p>{pricingObj.cntrctMax}</p>
            </div>
            <div>
              Annual Frequency of Buys (AFB): <p>{pricingObj.afb}</p>
            </div>
          </div>
          <div className="inline">
            <div>
              Minimum Order Quantity: <p>{pricingObj.minOrderQnty}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.minOrderQnty ? (
            <Errors validation={validation[validatationKeys.minOrderQnty]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.quantityUpper ? (
            <Errors validation={validation[validatationKeys.quantityUpper]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.minOrderQntyBool ? (
            <Errors
              validation={validation[validatationKeys.minOrderQntyBool]}
            />
          ) : (
            <div />
          )}
        </div>
      );
    });

  return (
    <div className="subcomponent-wrapper">
      <div className="subcomponent-header">Pricing</div>
      <Card>
        {createItems(data)}
        <div className="edit-button-dibbs">
          <Button
            type="primary"
            onClick={() => {
              changeMenu('pricing');
            }}
          >
            Edit
          </Button>
        </div>
      </Card>

      <Divider />
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/reviewComponents/pricing.jsx